import requests from "./httpService";

const SoldOutServices = {
  getAllSoldOut: async () => {
    return requests.get(`/soldOut/`);
  },

  addSoldOut: async (body) => {
    return requests.post(`/soldOut/add`, body);
  },
  getSoldOutById: async (id) => {
    return requests.get(`/soldOut/${id}`);
  },
  updateSoldOut: async (id, body) => {
    return requests.put(`/soldOut/update/${id}`, body);
  },

  deleteSoldout: async (id) => {
    return requests.delete(`/soldOut/delete/${id}`);
  },

  getAllHourSold: async () => {
    return requests.get(`/place/getCities/Hour Rental/`);
  },
  getAllAirDropSold: async () => {
    return requests.get(`/place/getCities/Airport Drop/`);
  },
  getAllAirPickSold: async () => {
    return requests.get(`/place/getCities/Airport Pickup/`);
  },
  getAllOutSold: async () => {
    return requests.get(`/place/getCities/Outstation/`);
  },
  getAllHolidaySold: async () => {
    return requests.get(`/place/getCities/Holiday Package/`);
  },
};

export default SoldOutServices;
